import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import Loader from 'Components/Loader';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const InputNotification = styled.span`
  text-align: right;
  text-decoration: none;
  color: red;
  font-size: 0.875rem;
  display: inline-block;
  padding: 0.5rem 0;
`;

const DownloadButton = styled(Button)`
  background: #fff !important;
  margin-right: 16px !important;
`;

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 500px;
  background-color: rgb(234, 234, 234);
  padding: 20px;
`;

const styles = theme => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: 'rgb(255, 202, 40)',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    color: 'grey',
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: 'rgb(234, 234, 234)',
    // display: 'flex',
    // flexDirection: 'column',
  },
}))(MuiDialogActions);

const CustomizedDialogs = props => {
  return (
    <Dialog
      onClose={props.closePasswordDialog}
      aria-labelledby="customized-dialog-title"
      open={props.open}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={props.closePasswordDialog}
      >
        Change password
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel
            classes={{
              root: 'label--c-gray',
            }}
          >
            Current password
          </InputLabel>
          <Input
            classes={{
              underline: 'underline--c-light',
            }}
            type={props.showCurrent ? 'text' : 'password'}
            value={props.currentPassword}
            onChange={props.handleChangeInput('currentPassword')}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={props.handleClickShowPassword('showCurrent')}
                  onMouseDown={props.handleMouseDownPassword}
                >
                  {props.showCurrent ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControl fullWidth className="u-mrg-top-50">
          <InputLabel
            classes={{
              root: 'label--c-gray',
            }}
          >
            New password
          </InputLabel>
          <Input
            classes={{
              underline: 'underline--c-light',
            }}
            type={props.showNew ? 'text' : 'password'}
            value={props.newPassword}
            onChange={props.handleChangeInput('newPassword')}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={props.handleClickShowPassword('showNew')}
                  onMouseDown={props.handleMouseDownPassword}
                >
                  {props.showNew ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControl fullWidth className="u-mrg-top-50">
          <InputLabel
            classes={{
              root: 'label--c-gray',
            }}
          >
            Confirm new password
          </InputLabel>
          <Input
            classes={{
              underline: 'underline--c-light',
            }}
            type={props.showConfirm ? 'text' : 'password'}
            value={props.confirmPassword}
            onChange={props.handleChangeInput('confirmPassword')}
            onBlur={props.handleBlurValidatePasswordConfirm(
              'confirmNewPasswordErr'
            )}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={props.handleClickShowPassword('showConfirm')}
                  onMouseDown={props.handleMouseDownPassword}
                >
                  {props.showConfirm ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          <InputNotification>{props.confirmNewPasswordErr}</InputNotification>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <InputNotification>
          {props.validateChangingPasswordFormErr}
        </InputNotification>
        <DownloadButton
          disabled={props.disabledButtonPassword}
          onClick={props.validateChangingPasswordForm}
          disabled={props.message === ''}
          autoFocus
          variant="contained"
          className="t-weight-b criteria-button"
        >
          <React.Fragment>
            <Loader isLoading={props.sending} size={32} />
            <p
              style={{
                visibility: props.sending ? 'hidden' : 'visible',
              }}
            >
              Save
            </p>
          </React.Fragment>
        </DownloadButton>
      </DialogActions>
    </Dialog>
  );
};

export default CustomizedDialogs;
